import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ServicesPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const services = [
    {
      id: 1,
      title: 'الإنشاءات',
      description: 'نقدم خدمات الإنشاءات والبناء بأعلى معايير الجودة والاحترافية',
      icon: 'ri-building-line',
      image: 'https://public.readdy.ai/ai/img_res/7d6264eed2b194bfa0545b88022a32a9.jpg',
      slug: 'construction'
    },
    {
      id: 2,
      title: 'الترميم',
      description: 'خدمات ترميم شاملة للمباني والمنشآت بأحدث التقنيات',
      icon: 'ri-hammer-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20building%20renovation%20and%20restoration%20work%2C%20skilled%20workers%20repairing%20and%20upgrading%20commercial%20facility%2C%20modern%20renovation%20techniques%20with%20quality%20materials%2C%20corporate%20construction%20photography%20with%20clean%20professional%20style&width=800&height=600&seq=service-renovation-002&orientation=landscape',
      slug: 'renovation'
    },
    {
      id: 3,
      title: 'تمديدات الأنابيب',
      description: 'تمديد الأنابيب بمختلف أنواعها بدقة واحترافية عالية',
      icon: 'ri-water-flash-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumbing%20and%20pipe%20installation%20work%2C%20industrial%20piping%20systems%20with%20various%20types%20of%20pipes%2C%20skilled%20technicians%20installing%20water%20and%20drainage%20systems%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=service-piping-003&orientation=landscape',
      slug: 'piping'
    },
    {
      id: 4,
      title: 'الأعمال الكهربائية',
      description: 'تمديد الأسلاك الكهربائية وأسلاك الاتصالات بأعلى معايير السلامة',
      icon: 'ri-flashlight-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrical%20installation%20work%2C%20electricians%20installing%20wiring%20and%20communication%20cables%20in%20commercial%20building%2C%20modern%20electrical%20systems%20with%20safety%20standards%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=service-electrical-004&orientation=landscape',
      slug: 'electrical'
    },
    {
      id: 5,
      title: 'الخدمات الميكانيكية',
      description: 'تركيب وصيانة الأعمال الميكانيكية والتكييف والتهوية',
      icon: 'ri-settings-3-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20HVAC%20and%20mechanical%20systems%20installation%2C%20technicians%20working%20on%20air%20conditioning%20and%20ventilation%20equipment%2C%20modern%20mechanical%20services%20in%20commercial%20facility%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=service-mechanical-005&orientation=landscape',
      slug: 'mechanical'
    },
    {
      id: 6,
      title: 'الأعمال المدنية',
      description: 'تركيب الأبواب والشبابيك والديكورات والمظلات والدهان والتبليط',
      icon: 'ri-paint-brush-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20civil%20construction%20work%20including%20doors%20windows%20painting%20and%20tiling%2C%20skilled%20workers%20doing%20interior%20finishing%20work%2C%20modern%20civil%20construction%20services%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=service-civil-006&orientation=landscape',
      slug: 'civil'
    },
    {
      id: 7,
      title: 'أنظمة السلامة',
      description: 'تركيب أنظمة الإطفاء والإنذار وحساسات الحريق والإطفاء بالغازات',
      icon: 'ri-fire-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20systems%20installation%2C%20fire%20suppression%20equipment%20with%20sprinklers%20and%20alarms%2C%20modern%20fire%20protection%20infrastructure%20with%20gas%20suppression%20systems%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=service-safety-007&orientation=landscape',
      slug: 'safety'
    },
    {
      id: 8,
      title: 'النظافة والمناظر الطبيعية',
      description: 'خدمات النظافة للمرافق وتنسيق المناظر الطبيعية',
      icon: 'ri-plant-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20facility%20cleaning%20and%20landscaping%20services%2C%20well-maintained%20commercial%20property%20with%20beautiful%20gardens%20and%20clean%20environment%2C%20modern%20landscape%20design%20with%20natural%20elements%2C%20corporate%20photography%20with%20professional%20quality&width=800&height=600&seq=service-cleaning-008&orientation=landscape',
      slug: 'cleaning'
    },
    {
      id: 9,
      title: 'تركيب المضخات',
      description: 'أعمال تركيب المضخات وتمديدها بأحدث التقنيات',
      icon: 'ri-contrast-drop-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20pump%20installation%20and%20piping%20work%2C%20industrial%20water%20pumps%20and%20pumping%20systems%2C%20skilled%20technicians%20installing%20modern%20pump%20equipment%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=service-pumps-009&orientation=landscape',
      slug: 'pumps'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#202835] shadow-lg' : 'bg-[#202835]'}`}>
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            <Link className="flex items-center" to="/">
              <img 
                alt="شركة الهمة الذهبية" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
              />
            </Link>

            <nav className="hidden lg:flex items-center gap-8">
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/">
                الرئيسية
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/about">
                من نحن
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group text-[#d4af37]" to="/services">
                الخدمات
                <span className="absolute bottom-0 right-0 w-full h-0.5 bg-[#d4af37]"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/projects">
                المشاريع
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/news">
                الأخبار
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </nav>

            <Link className="hidden lg:block px-8 py-3 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer" to="/contact">
              تواصل معنا
            </Link>

            <button 
              className="lg:hidden text-white text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#202835] border-t border-white/10">
            <nav className="container mx-auto px-6 py-4 flex flex-col gap-4">
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/">الرئيسية</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link>
              <Link className="text-white font-semibold text-[#d4af37] transition-colors" to="/services">الخدمات</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/contact">تواصل معنا</Link>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="relative h-[60vh] w-full overflow-hidden mt-24">
        <div className="absolute inset-0 w-full h-full">
          <img 
            alt="خدمات شركة الهمة الذهبية" 
            className="w-full h-full object-cover object-center" 
            src="https://readdy.ai/api/search-image?query=Professional%20construction%20services%20showcase%20with%20multiple%20construction%20activities%2C%20diverse%20construction%20work%20including%20building%20electrical%20plumbing%20and%20safety%20systems%2C%20comprehensive%20construction%20company%20services%20banner%2C%20corporate%20photography%20with%20professional%20quality&width=1920&height=1080&seq=services-hero-banner-001&orientation=landscape"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#202835]/80 via-[#202835]/70 to-[#202835]/80"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">خدماتنا</h1>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto mb-6"></div>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              نقدم مجموعة شاملة من الخدمات في مجال المقاولات والإنشاءات
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <Link
                key={service.id}
                to={`/services/${service.slug}`}
                className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full h-[280px] overflow-hidden">
                  <img
                    alt={service.title}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                    src={service.image}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/80 to-transparent"></div>
                  <div className="absolute bottom-6 right-6">
                    <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center">
                      <i className={`${service.icon} text-3xl text-white`}></i>
                    </div>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-[#202835] mb-4 group-hover:text-[#d4af37] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-[#202835]/70 leading-relaxed mb-6">
                    {service.description}
                  </p>
                  <div className="flex items-center gap-2 text-[#d4af37] font-semibold group-hover:gap-3 transition-all duration-300">
                    <span>اعرف المزيد</span>
                    <i className="ri-arrow-left-line"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-[#202835] text-white overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <Link className="inline-block mb-6" to="/">
                <img 
                  alt="شركة الهمة الذهبية" 
                  className="h-16 w-auto" 
                  src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
                />
              </Link>
              <p className="text-white/80 leading-relaxed mb-6">
                شركة الهمة الذهبية، شريكك الموثوق في عالم المقاولات والإنشاءات.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">روابط سريعة</h3>
              <ul className="space-y-3">
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">خدماتنا</h3>
              <ul className="space-y-3">
                <li className="text-white/80">الإنشاءات والبناء</li>
                <li className="text-white/80">الترميم والصيانة</li>
                <li className="text-white/80">الأعمال الكهربائية</li>
                <li className="text-white/80">أنظمة السلامة</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">تواصل معنا</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-phone-line text-[#d4af37] text-xl mt-1"></i>
                  <div>
                    <div dir="ltr">+966 50 016 5920</div>
                    <div dir="ltr">+966 50 125 5250</div>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-mail-line text-[#d4af37] text-xl mt-1"></i>
                  <span>info@gmcc.com.sa</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 py-6">
            <p className="text-white/60 text-sm text-center">
              © 2024 شركة الهمة الذهبية. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
